<template>
    <div>
        <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
            <template slot="title">Forms</template>
        </page-header>
        <pro-table
            :resource="resource"
            prefix="/configuration/"
            :fields="fields"
            :filters="filters"
            :filters-loading="filtersLoading"
            :limit="25"
            ref="datatable"
            class="px-6 pt-2"
            @action="actionHandler"
            sort="name"
            direction="ASC"
            delete-label="name"
        ></pro-table>
    </div>
</template>

<script>
    import DataTableSetup from '@/mixins/DataTableSetup';

    export default {
        name: "forms",
        mixins: [ DataTableSetup ],
        data: function() {
            return {
                resource: 'forms',
                numberOfFilters: 1,
                pageActions: {
                    buttons: [
                        {
                            label: 'New Form',
                            icon: 'plus',
                            type: 'router-link',
                            link: '/configuration/application-forms/create',
                            iconClass: 'text-green-600'
                        }
                    ],
                    additional: []
                },
                fields: [
                    {
                        name: 'Name',
                        column: 'name',
                    }
                ]
            }
        },
        methods: {
            methodHandler: function(method){
                this[method]();
            },
        },
        mounted() {
            //Search Filter
            const searchFilter = {
                label: 'Search',
                name: 'search',
                type: 'text',
                width: 'w-1/4',
                value: this.searchValue,
                placeholder: 'Search...'
            };

            this.filters.push(searchFilter);
        }
    }
</script>

<style scoped>

</style>
